import * as React from 'react';
import styled, { css } from 'styled-components';
import { Button, ButtonProps } from '@material-ui/core';

const ButtonMain = ({
  variant = 'contained',
  color = 'primary',
  ...props
}: ButtonProps) => (
  <StyledButton
    variant={variant}
    color={color}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

const base = css`
  min-width: 112px;
  min-height: 36px;
  padding: 0 16px;
  border-radius: var(--radius-md);
  font-family: inherit;
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.2px;
  text-transform: none;
  line-height: 1;
  transition:
    background-color var(--motion-fast) var(--ease-standard),
    color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard),
    transform var(--motion-fast) var(--ease-standard);

  &:focus-visible {
    box-shadow: var(--shadow-focus);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const StyledButton = styled(Button)`
  ${base}
  color: var(--neutral-700);
  background: var(--neutral-100);

  &:hover {
    color: var(--neutral-800);
    background: var(--neutral-200);
  }

  &.MuiButton-containedPrimary {
    color: var(--neutral-0);
    background-color: var(--primary-600);
    box-shadow: var(--shadow-xs);

    &:hover {
      background-color: var(--primary-700);
      box-shadow: var(--shadow-sm);
    }
  }

  &.MuiButton-containedSecondary {
    color: var(--neutral-0);
    background-color: var(--danger-500);
    box-shadow: var(--shadow-xs);

    &:hover {
      background-color: var(--danger-600);
      box-shadow: var(--shadow-sm);
    }
  }

  &.MuiButton-root {
    line-height: 1;
  }

  &.MuiButton-root.Mui-disabled {
    background-color: var(--neutral-200);
    color: var(--neutral-400);
    box-shadow: none;
  }
`;

export default ButtonMain;
